import { validateSubLocationSave } from '../utils/sublocationValidations';

/**
 * Custom hook for validating sub-location save with area tax location check
 * @param {Object} subLocationDetails - The sub-location details
 * @param {Array} areaTaxLocations - List of available area tax locations
 * @param {Function} setShowInactiveAreaTaxModal - Optional setter to show modal (if not provided, uses internal state)
 * @returns {Object} - { validateBeforeSave }
 */
export const useSubLocationSaveValidation = (subLocationDetails, areaTaxLocations, setShowInactiveAreaTaxModal) => {
  /**
   * Validates area tax location before saving
   * @param {Object} formValues - Form values containing areaTaxLocation
   * @returns {boolean} - True if validation passes, false otherwise
   */
  const validateBeforeSave = (formValues) => {
    if (!formValues || !subLocationDetails) {
      console.warn('formValues and subLocationDetails are required for save validation');
      return false;
    }

    try {
      const validation = validateSubLocationSave(
        {
          areaTaxLocationId: formValues?.areaTaxLocation?.id,
          areaTaxLocation: formValues?.areaTaxLocation,
        },
        subLocationDetails,
        areaTaxLocations || [],
      );

      if (validation.hasInactiveAreaTax) {
        if (setShowInactiveAreaTaxModal) {
          setShowInactiveAreaTaxModal(true);
        }
        return false;
      }

      return true;
    } catch (error) {
      console.warn('Failed to validate sub-location save request', error);
      return false;
    }
  };

  return {
    validateBeforeSave,
  };
};
